var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgConferences(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#conferences_svg__clip0_625_515)",
    stroke: "#311E72",
    strokeWidth: 0.884
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.631 12.338H7.775V24.2h9.856V12.338z",
    fill: "#DAD7FD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.93 9.659H5.475c0 .698 0 1.954.847 2.652h12.93c.676-.745.665-2.017.676-2.652z",
    fill: "#DAD7FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.714 24.228h11.978M10.537 9.659c-.386-.813-.98-2.803 1.842-3.232 1.876-.285 2.865-1.489 2.865-2.249"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.377 1.084h-.354a.972.972 0 00-.972.972v1.15c0 .537.435.972.972.972h.354a.972.972 0 00.972-.972v-1.15a.972.972 0 00-.972-.972zM12.703 20.355a1.746 1.746 0 100-3.492 1.746 1.746 0 000 3.492z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "conferences_svg__clip0_625_515"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.703 .642)",
    d: "M0 0h24v24H0z"
  })))));
}

export default SvgConferences;